import React from 'react';
import { motion } from 'framer-motion';
export function SectionDivider() {
  return <div className="w-full flex items-center justify-center py-16 opacity-60" data-id="element-165">
      <div className="w-24 h-[1px] bg-gradient-to-r from-transparent to-gold-500/50" data-id="element-166" />
      <motion.div initial={{
      scale: 0,
      rotate: -45
    }} whileInView={{
      scale: 1,
      rotate: 45
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="w-2 h-2 border border-gold-400 mx-4" data-id="element-167" />
      <div className="w-24 h-[1px] bg-gradient-to-l from-transparent to-gold-500/50" data-id="element-168" />
    </div>;
}